export default "__VITE_ASSET__g25ackJq__"